import type { SiteContent } from '../content/types';
import { Container } from '../components/layout/container';
import { PageHero } from '../components/sections/page-hero';
import { Badge } from '../components/ui/badge';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';

interface TeamPageProps {
  content: SiteContent;
}

export function TeamPage({ content }: TeamPageProps): JSX.Element {
  return (
    <>
      <PageHero title={content.teamPage.heroTitle} text={content.teamPage.heroText} />
      <section className="pb-12 sm:pb-16">
        <Container className="space-y-6">
          <Card className="bg-white">
            <CardContent className="p-6 text-sm text-[color:var(--color-muted)]">{content.teamPage.intro}</CardContent>
          </Card>

          <div className="grid gap-4 md:grid-cols-3">
            {content.teamPage.members.map((member) => (
              <Card key={member.name} className="overflow-hidden bg-white">
                <div className="aspect-[4/3] bg-[linear-gradient(145deg,var(--color-primary-soft),var(--color-accent))] p-5">
                  <div className="flex h-full items-end rounded-xl border border-white/80 bg-white/70 p-4 backdrop-blur">
                    <p className="text-sm font-semibold text-[color:var(--color-text)]">{member.name}</p>
                  </div>
                </div>
                <CardHeader className="pb-2">
                  <CardTitle className="text-base">{member.role}</CardTitle>
                </CardHeader>
                <CardContent className="space-y-3">
                  <p className="text-sm text-[color:var(--color-muted)]">{member.bio}</p>
                  <Badge>{member.sourceStatus}</Badge>
                </CardContent>
              </Card>
            ))}
          </div>

          <Card className="bg-[color:var(--color-surface-alt)]">
            <CardContent className="p-6 text-sm text-[color:var(--color-muted)]">{content.teamPage.placeholderNotice}</CardContent>
          </Card>
        </Container>
      </section>
    </>
  );
}
